/**
 * Copyright 2016 xdot GmbH
 * Author: Carsten Hibbeler
 * Date: 31.08.2016
 */

export const METRIC_TYPE = {
    SERIES: 'series',
    DATA_POINTS: 'datapoints',
    REFERENCE_VALUES: 'reference_values'
};


/**
 * https://prometheus.io/docs/concepts/data_model/
 *
 *  Notation
 *  Given a metric name and a set of labels, time series are frequently identified using this notation:
 *
 *  <metric name>{<label name>=<label value>, ...}
 *  For example, a time series with the metric name api_http_requests_total and the labels method="POST" and handler="/messages" could be written like this:
 *
 *  api_http_requests_total{method="POST", handler="/messages"}
 *  This is the same notation that OpenTSDB uses.
 *
 */
export default function uniqueId(series) {
    return series.metric + '{' +
        Object.keys(series.labels)
            .map(label => label + '=' + series.labels[ label ])
            .join(',') + '}';
}



// WEBPACK FOOTER //
// ./js/utils/timeseries-util.js